import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

import type { CoachingCoacheeCohortPathParams } from '../../cohort';

/** Old History URL — send people to Past. */
export default class CoachingCoacheeCohortSessionsHistoryRoute extends Route {
  @service declare router: RouterService;

  beforeModel(): void {
    const { program_id, cohort_id } = this.paramsFor(
      'coaching.coachee.cohort'
    ) as CoachingCoacheeCohortPathParams;

    this.router.replaceWith(
      'coaching.coachee.cohort.sessions.past',
      program_id,
      cohort_id
    );
  }
}
